/**
 * Numéro WhatsApp affiché et utilisé pour les liens wa.me.
 * En production : définir VITE_WHATSAPP_NUMBER (ex. +903212345678).
 * Si non défini, les liens WhatsApp sont désactivés ou remplacés par le mail.
 */
const RAW = typeof import.meta !== "undefined" && import.meta.env?.VITE_WHATSAPP_NUMBER;
export const WHATSAPP_NUMBER = typeof RAW === "string" && RAW.trim() ? RAW.trim() : "";
export const HAS_WHATSAPP = WHATSAPP_NUMBER.length > 0;

/** Numéro formaté pour affichage (masqué si non configuré) */
export function getWhatsAppDisplayNumber(): string {
  if (!HAS_WHATSAPP) return "";
  const digits = WHATSAPP_NUMBER.replace(/\D/g, "");
  if (digits.length < 10) return WHATSAPP_NUMBER;
  const country = digits.slice(0, 2);
  const rest = digits.slice(2);
  return `+${country} ${rest.slice(0, 3)} ${rest.slice(3, 6)} ${rest.slice(6)}`;
}

/** URL wa.me (vide si non configuré) */
export function getWhatsAppLink(message?: string): string {
  if (!HAS_WHATSAPP) return "";
  const digits = WHATSAPP_NUMBER.replace(/\D/g, "");
  const q = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${q}`;
}
